import React from 'react';
import { number } from 'prop-types';

import { decimalFormat, formatPercentage } from '@ajaibid/utils';
import { Typography } from '@ajaibid/components';

import { getTickerStyle } from './helpers';
import { styPriceChangeTicker } from './style';

const PriceChangeTicker = (props) => {
  const { change, percentage, ...rest } = props;

  const { color, icon } = getTickerStyle(change);

  return (
    <Typography
      className={styPriceChangeTicker(icon)}
      type="label"
      size="xs"
      color={color}
      margin={0}
      {...rest}
    >
      {decimalFormat(change)}
      &nbsp;
      {formatPercentage(percentage, 2, { bracket: true, sign: true })}
    </Typography>
  );
};

PriceChangeTicker.propTypes = {
  change: number,
  percentage: number,
};

PriceChangeTicker.defaultProps = {
  change: 0,
  percentage: 0,
};

export default PriceChangeTicker;
